"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function addPrivacyPolicyUrlToConsentDialog() {
    const consentDialogMainText = document.querySelector("#CybotCookiebotDialogBodyContentText");
    if (consentDialogMainText) {
        let privacyPolicyText = "";
        let privacyPolicyUrl = "";
        switch (window.location.hostname) {
            case 'eu.mondaine.com':
                privacyPolicyText = window.Shopify.locale === "de" ? "Datenschutzerklärung: " : "Privacy policy: ";
                privacyPolicyUrl = "https://eu.mondaine.com/pages/datenschutzerklaerung";
                break;
            case 'de.mondaine.com':
                privacyPolicyText = window.window.Shopify.locale === "de" ? "Datenschutzerklärung: " : "Privacy policy: ";
                privacyPolicyUrl = "https://de.mondaine.com/pages/datenschutzerklaerung";
                break;
            case 'ch.mondaine.com':
                privacyPolicyText = window.Shopify.locale === "de" ? "Datenschutzerklärung: " : "Privacy policy: ";
                privacyPolicyUrl = "https://ch.mondaine.com/pages/datenschutzerklaerung";
                break;
            case 'uk.mondaine.com':
                privacyPolicyText = "Privacy policy: ";
                privacyPolicyUrl = "https://uk.mondaine.com/pages/privacy-statement";
                break;
            case 'mondaine.com':
                privacyPolicyText = "Privacy policy: ";
                privacyPolicyUrl = "https://mondaine.com/policies/privacy-policy";
                break;
            case 'eu.luminox.com':
                privacyPolicyText = window.Shopify.locale === "de" ? "Datenschutzerklärung: " : "Privacy policy: ";
                privacyPolicyUrl = "https://eu.luminox.com/policies/privacy-policy";
                break;
            case 'de.luminox.com':
                privacyPolicyText = window.window.Shopify.locale === "de" ? "Datenschutzerklärung: " : "Privacy policy: ";
                privacyPolicyUrl = "https://de.luminox.com/policies/privacy-policy";
                break;
            case 'ch.luminox.com':
                privacyPolicyText = window.Shopify.locale === "de" ? "Datenschutzerklärung: " : "Privacy policy: ";
                privacyPolicyUrl = "https://ch.luminox.com/policies/privacy-policy";
                break;
            case 'uk.luminox.com':
                privacyPolicyText = "Privacy policy: ";
                privacyPolicyUrl = "https://uk.luminox.com/policies/privacy-policy";
                break;
            case 'luminox.com':
                privacyPolicyText = "Privacy policy: ";
                privacyPolicyUrl = "https://luminox.com/pages/privacy-policy";
                break;
        }
        if (privacyPolicyText && privacyPolicyUrl) {
            const privacyPolicyUrlTag = "<a href='" + privacyPolicyUrl + "'>" + privacyPolicyUrl + "</a>";
            consentDialogMainText.innerHTML += "<br>" + privacyPolicyText + privacyPolicyUrlTag;
        }
    }
}
window.addEventListener('CookiebotOnDialogDisplay', function () {
    addPrivacyPolicyUrlToConsentDialog();
});
